import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory, Link } from "react-router-dom";
import { authService } from "../../services/authService";
import { toast } from "react-toastify";
import { Card, Button, Spinner } from "react-bootstrap";
import { GoogleLogin } from "@react-oauth/google";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email invalide")
    .required("L'email est obligatoire"),
  password: Yup.string().required("Le mot de passe est obligatoire"),
});

const Login = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      await authService.login(values.email, values.password, rememberMe);
      toast.success("Connexion réussie !");
      // Use setTimeout to ensure localStorage is written before redirect
      setTimeout(() => {
        window.location.href = "/commande";
      }, 100);
    } catch (error) {
      toast.error(error.response?.data?.message || "Erreur de connexion");
      setIsLoading(false);
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    setIsLoading(true);
    try {
      const result = await authService.googleLogin(credentialResponse.credential);

      // Si le profil est incomplet, rediriger vers la page de complétion
      if (result.profileIncomplete) {
        toast.info("Complète ton profil pour finaliser ton inscription");
        setTimeout(() => {
          window.location.href = "/complete-profile";
        }, 100);
      } else {
        toast.success("Connexion avec Google réussie !");
        setTimeout(() => {
          window.location.href = "/commande";
        }, 100);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Erreur de connexion avec Google");
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    toast.error("Erreur lors de la connexion avec Google");
  };

  return (
    <div className="login-page d-flex align-items-center justify-content-center py-5 bg-light">
      <Card className="login-card shadow" style={{ maxWidth: "450px", width: "100%" }}>
        <Card.Body className="p-5">
          <div className="text-center mb-4">
            <h2 className="mb-3">Marion Livraison</h2>
            <h4 className="text-muted">Connexion</h4>
          </div>

          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <Field
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="ton@email.com"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger mt-1"
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Mot de passe</label>
                  <div className="position-relative">
                    <Field
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="form-control"
                      placeholder="••••••••"
                    />
                    <button
                      type="button"
                      className="btn btn-sm position-absolute end-0 top-50 translate-middle-y"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ background: "none", border: "none", zIndex: 10 }}
                    >
                      {showPassword ? (
                        <i className="fas fa-eye-slash"></i>
                      ) : (
                        <i className="fas fa-eye"></i>
                      )}
                    </button>
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-danger mt-1"
                  />
                </div>

                <div className="mb-3 text-end">
                  <Link to="/forgot-password" className="text-decoration-none">
                    Mot de passe oublié ?
                  </Link>
                </div>

                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="rememberMe"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="rememberMe">
                    Se souvenir de moi
                  </label>
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  className="w-100 mb-3"
                  disabled={isLoading || isSubmitting}
                >
                  {isLoading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        className="me-2"
                      />
                      Connexion...
                    </>
                  ) : (
                    "Se connecter"
                  )}
                </Button>

                <div className="text-center mb-3">
                  <div className="d-flex align-items-center mb-3">
                    <hr className="flex-grow-1" />
                    <span className="mx-3 text-muted">ou</span>
                    <hr className="flex-grow-1" />
                  </div>

                  <div className="d-flex justify-content-center">
                    <GoogleLogin
                      onSuccess={handleGoogleSuccess}
                      onError={handleGoogleError}
                      text="continue_with"
                      locale="fr"
                      shape="rectangular"
                      size="large"
                      width="100%"
                    />
                  </div>
                </div>

                <div className="text-center">
                  Pas encore de compte ?{" "}
                  <Link to="/register">S'inscrire</Link>
                </div>
              </Form>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Login;
